// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MwwP5nu2toWaoN {
  display: block;
  flex-shrink: 0;
  align-self: flex-start;
  padding: 0 6px;
}
@media print {
  .MwwP5nu2toWaoN {
    display: none;
  }
}
.vVqwaYKVgTygrk {
  box-sizing: border-box;
  width: 272px;
  padding: 8px;
  border-radius: 12px;
  background-color: var(--tr-background-list);
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.oe8RymzptORQ7h {
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  display: block;
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  min-height: 20px;
  max-height: 256px;
  margin: 0;
  padding: 6px 12px;
  overflow: hidden;
  border: none;
  border-radius: 4px;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-semibold, 600);
  resize: none;
  overflow-wrap: break-word;
  /* Focus State */
}
.oe8RymzptORQ7h:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.oe8RymzptORQ7h:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.oe8RymzptORQ7h:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.oe8RymzptORQ7h[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.oe8RymzptORQ7h.xOsxZkgxFXpUpu {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.oe8RymzptORQ7h.xOsxZkgxFXpUpu:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.oe8RymzptORQ7h.xOsxZkgxFXpUpu:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.oe8RymzptORQ7h.ozZzRoqnCucRBh {
  width: 100%;
}
.oe8RymzptORQ7h::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.oe8RymzptORQ7h:focus {
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.oe8RymzptORQ7h::placeholder {
  font-weight: var(--ds-font-weight-semibold, 600);
}
.zqgdmniUdb1ZQ7 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 8px;
  border-radius: 4px;
  gap: 4px;
}
[data-testid='jira-datasource-modal'] fieldset {
  margin-bottom: 0;
  border: 0;
}
[data-testid='jira-datasource-modal'] input {
  margin-bottom: 0;
  box-shadow: none;
}
[data-testid='jira-datasource-modal'] input:focus {
  box-shadow: none;
}
[data-testid='jira-datasource-modal'] input[type='radio'] {
  display: none;
}
[data-testid='jira-datasource-modal'] label {
  margin-top: 0px;
  margin-bottom: 0px;
}
[data-testid*='jlol-basic-filter'] input, [data-testid*='jlol-basic-filter'] input:focus {
  box-shadow: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listComposerContainer": `MwwP5nu2toWaoN`,
	"listComposer": `vVqwaYKVgTygrk`,
	"listNameTextarea": `oe8RymzptORQ7h`,
	"input-error": `xOsxZkgxFXpUpu`,
	"full": `ozZzRoqnCucRBh`,
	"listComposerSubmit": `zqgdmniUdb1ZQ7`
};
export default ___CSS_LOADER_EXPORT___;
